module.exports = __webpack_public_path__ + "img/weus1.5fba4a2b.jpg";